import { render, staticRenderFns } from "./valores.vue?vue&type=template&id=1626d43c"
import script from "./valores.vue?vue&type=script&lang=js"
export * from "./valores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports